async function alertIfInQuebec() {
  if (!window.userLocation) return;
  if(window.location.pathname.includes("/fr")) return;


  const locationState = window.userLocation.data.state;
  if (!locationState) return;

  const modal = document.getElementById("rove-country-switcher");
  if (!modal) return;

  //if(localStorage.getItem("rove-country-switcher-alerted") && localStorage.getItem("debug_country_switcher") != "true") return;
  if (!String(locationState).toLowerCase().includes("quebec")) return;
  
  modal.showModal();
  localStorage.setItem("rove-country-switcher-alerted", true);

  modal.addEventListener("click", (e)=>{
    if (e.target === modal) modal.close();
  });
  
}
window.addEventListener("rove:userLocationSet", alertIfInQuebec);